import { render } from "./Modal.vue?vue&type=template&id=131553f5&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=131553f5&scoped=true&lang=css"

import exportComponent from "D:\\Mindscan\\online-quiz-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131553f5"]])

export default __exports__